import React from "react";

import "./styling/BootScreen.css";

/*
  BootScreen — full-page branded loading screen shown once at app startup,
  while the mount-time session restore settles (App.js, `!authReady`).

  Deliberately separate from LoadingSpinner: that component is used inline in
  ~19 places, and a brand mark on every inline spinner would be noise. This one
  is the single full-page boot moment, so it earns the logo.

  The Orecasting icon (masked over the brand gradient — same technique as the
  nav lockup) sits above a slim progress ring. Marked aria-busy/role=status so
  the boot state is announced; the visual is aria-hidden.
*/
const BootScreen = () => {
  return (
    <div className="boot-screen" role="status" aria-live="polite" aria-label="Loading Orecasting">
      <div className="boot-screen__inner" aria-hidden="true">
        <span className="boot-screen__mark" />
        <span className="boot-screen__ring" />
      </div>
      <span className="boot-screen__sr-text">Loading Orecasting…</span>
    </div>
  );
};

export default BootScreen;
